import gsap from "gsap";

class Button {
  constructor(button) {
    this.block = button;
    this.init();
    this.initEvents();
  }

  init() {
    const el = gsap.utils.selector(this.block);

    this.DOM = {
      button: this.block,
      flair: el(".btn-blob")
    };

    this.xSet = gsap.quickSetter(this.DOM.flair, "xPercent");
    this.ySet = gsap.quickSetter(this.DOM.flair, "yPercent");
  }

  getXY(e) {
    const {
      left,
      top,
      width,
      height
    } = this.DOM.button.getBoundingClientRect();

    const xTransformer = gsap.utils.pipe(
      gsap.utils.mapRange(0, width, 0, 100),
      gsap.utils.clamp(0, 100)
    );

    const yTransformer = gsap.utils.pipe(
      gsap.utils.mapRange(0, height, 0, 100),
      gsap.utils.clamp(0, 100)
    );

    return {
      x: xTransformer(e.clientX - left),
      y: yTransformer(e.clientY - top)
    };
  }

  initEvents() {
    this.DOM.button.addEventListener("mouseenter", (e) => {
      const { x, y } = this.getXY(e);

      this.xSet(x);
      this.ySet(y);

      gsap.to(this.DOM.flair, {
        scale: 1,
        duration: 0.6,
        ease: "power2.out"
      });
    });

    this.DOM.button.addEventListener("mouseleave", (e) => {
      const { x, y } = this.getXY(e);

      gsap.killTweensOf(this.DOM.flair);

      gsap.to(this.DOM.flair, {
        xPercent: x > 90 ? x + 20 : x < 10 ? x - 20 : x,
        yPercent: y > 90 ? y + 20 : y < 10 ? y - 20 : y,
        scale: 0,
        duration: 0.3,
        ease: "power2.out"
      });
    });

    this.DOM.button.addEventListener("mousemove", (e) => {
      const { x, y } = this.getXY(e);

      gsap.to(this.DOM.flair, {
        xPercent: x,
        yPercent: y,
        duration: 0.4,
        ease: "power2"
      });
    });
  }
}

const initMagnetButton = (button) => {
  let boundingRect = button.getBoundingClientRect();

  const updateBoundingRect = () => {
    boundingRect = button.getBoundingClientRect();
  };

  const calculateMousePosition = (e) => {
    const mousePosX = e.clientX - boundingRect.left;
    const mousePosY = e.clientY - boundingRect.top;
    return { mousePosX, mousePosY };
  };

  const throttle = (func, limit) => {
    let inThrottle;
    return (...args) => {
      if (!inThrottle) {
        func(...args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  };

  const onMouseMove = throttle((e) => {
    const { mousePosX, mousePosY } = calculateMousePosition(e);

    gsap.to(button, {
      x: (mousePosX - boundingRect.width / 2) * 0.4,
      y: (mousePosY - boundingRect.height / 2) * 0.4,
      duration: 0.4,
      ease: "power3.out",
      overwrite: "auto",
    });
  }, 16);

  const onMouseLeave = () => {
    gsap.to(button, {
      x: 0,
      y: 0,
      duration: 0.8,
      ease: "elastic.out(1, 0.3)",
      overwrite: "auto",
    });
  };

  window.addEventListener("resize", updateBoundingRect);
  button.addEventListener("mouseenter", updateBoundingRect);
  button.addEventListener("mousemove", onMouseMove);
  button.addEventListener("mouseleave", onMouseLeave);
};

export default {
  init: () => {
    const buttons = document.querySelectorAll(".btn");

    buttons.forEach((button) => {
      new Button(button);
    });

    const magnetButtons = document.querySelectorAll(".btn-magnet");

    magnetButtons.forEach((button) => {
      initMagnetButton(button);
    });
  },
  Button,
  initMagnetButton
};
